{
  "schema_version": 1,
  "task_id": "L5-LOCAL-PRODUCT-POLISH-ROADMAP-001",
  "status": "local-product-polish-roadmap-ready",
  "source_entry_point": "continue-local-product-polish",
  "generated_at": "2026-07-31T12:20:00+08:00",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "tool_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "roadmap_item_count": 5,
    "safe_without_user_input_count": 5,
    "can_execute_external_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "remaining_user_decision_count": 3,
    "visible_capability": "local-product-polish-roadmap-readonly"
  },
  "roadmap_items": [
    {
      "id": "aios-home-comprehension",
      "priority": 1,
      "title_zh": "让 AIOS Home 一眼可懂",
      "title_en": "Make AIOS Home immediately understandable",
      "outcome_zh": "把创作入口、能力边界、下一步行动和风险提示组织成用户能直接上手的首页。",
      "outcome_en": "Organize creative entry, capability boundaries, next actions and risk cues into a home surface users can act from.",
      "allowed_effect": "local_ui_docs_tests_only",
      "safe_without_user_input": true,
      "can_execute_external": false,
      "evidence_sources": [
        "artifacts/evidence/GUI-AIOS-HOME-001",
        "artifacts/evidence/GUI-CREATIVE-LOOP-001"
      ]
    },
    {
      "id": "creative-flow-clarity",
      "priority": 2,
      "title_zh": "把创作闭环从“表”变成流程",
      "title_en": "Turn the creative loop from tables into flow",
      "outcome_zh": "继续把 Brief、Task Spec、Intent、Preview、Feedback 做成自然连续的创作路径。",
      "outcome_en": "Continue shaping Brief, Task Spec, Intent, Preview and Feedback into one continuous creative path.",
      "allowed_effect": "local_ui_docs_tests_only",
      "safe_without_user_input": true,
      "can_execute_external": false,
      "evidence_sources": [
        "artifacts/evidence/L5-CREATIVE-STARTER-SURFACE-001",
        "artifacts/evidence/L5-EXTERNAL-ACTION-SAFETY-HARNESS-UI-SURFACE-001"
      ]
    },
    {
      "id": "official-site-living-blueprint",
      "priority": 3,
      "title_zh": "官网继续做 Living Blueprint",
      "title_en": "Keep the official site as a Living Blueprint",
      "outcome_zh": "官网负责解释 AIOS 是什么、当前做到哪、为何外部动作还要用户决策。",
      "outcome_en": "The site explains what AIOS is, where it stands, and why external actions still require user decisions.",
      "allowed_effect": "local_ui_docs_tests_only",
      "safe_without_user_input": true,
      "can_execute_external": false,
      "evidence_sources": [
        "artifacts/evidence/L5-FINAL-HANDOFF-UI-SURFACE-001",
        "artifacts/evidence/L5-FINAL-HANDOFF-PACK-001"
      ]
    },
    {
      "id": "runtime-preview-trust",
      "priority": 4,
      "title_zh": "增强受控 Runtime 预览信任感",
      "title_en": "Increase trust in governed Runtime preview",
      "outcome_zh": "继续强化只读 receipt、风险解释、权限徽章和停止条件，避免用户误以为已经真实执行。",
      "outcome_en": "Strengthen read-only receipts, risk explanations, permission badges and stop conditions so users do not mistake preview for real execution.",
      "allowed_effect": "local_ui_docs_tests_only",
      "safe_without_user_input": true,
      "can_execute_external": false,
      "evidence_sources": [
        "artifacts/evidence/DESKTOP-RUNTIME-GOVERNED-ACTION-PREVIEW-001",
        "artifacts/evidence/L5-EXTERNAL-ACTION-SAFETY-HARNESS-001"
      ]
    },
    {
      "id": "local-model-advisory-ux",
      "priority": 5,
      "title_zh": "本地模型保持建议层",
      "title_en": "Keep local models in the advisory layer",
      "outcome_zh": "继续把 qwen / Ollama 等本地模型输出限制为 proposal / quarantine / deny，不给事实或执行权。",
      "outcome_en": "Keep qwen / Ollama local model outputs limited to proposal / quarantine / deny, without fact or execution authority.",
      "allowed_effect": "local_ui_docs_tests_only",
      "safe_without_user_input": true,
      "can_execute_external": false,
      "evidence_sources": [
        "artifacts/evidence/BC1-LOCAL-MODEL-INFRA-001",
        "artifacts/evidence/BEA-LOCAL-MODEL-ROUTER-POLICY-SIM-001"
      ]
    }
  ],
  "quality_gates": [
    "Task Spec",
    "Evidence",
    "Reviewer",
    "lint/build/test",
    "no external effect"
  ],
  "default_blockers": [
    "no_login",
    "no_oauth",
    "no_secret_collection",
    "no_external_write",
    "no_deployment",
    "no_runtime_activation",
    "no_model_fact_authority",
    "no_paid_action"
  ],
  "links": {
    "final_handoff_pack": "config/l5-final-handoff-pack.json",
    "completion_map": "config/l5-completion-map.json",
    "project_status": "config/aios-project-status.json"
  }
}
